import { render, staticRenderFns } from "./TotalStockByDepartment.vue?vue&type=template&id=68accb06&scoped=true&"
import script from "./TotalStockByDepartment.vue?vue&type=script&lang=ts&"
export * from "./TotalStockByDepartment.vue?vue&type=script&lang=ts&"
import style0 from "./TotalStockByDepartment.vue?vue&type=style&index=0&id=68accb06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68accb06",
  null
  
)

export default component.exports